// World 4 (Ashwood) — the final free world. Ships in two parts:
//   Part A (L1-L10): tools/generate-world4-v3.mjs — d=5 opener → d=7 climax.
//   Part B (L11-L20): tools/generate-world4-b.mjs — bonus d=6 pack, parallel
//     seed region. Extends the free tier so players are more invested before
//     hitting the paywall at the W4→W5 boundary.
import type { LevelDef } from '@tessera/engine';
import { WORLD_4_GENERATED } from './world4-generated';
import { WORLD_4B_GENERATED } from './world4b-generated';

export const WORLD_4_LEVELS: LevelDef[] = [...WORLD_4_GENERATED, ...WORLD_4B_GENERATED];
